var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_337_385",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_337_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.349 2.54158L17.3296 2.52393C16.961 2.18656 16.4793 1.99962 15.9796 2C15.7014 2.00026 15.4263 2.05834 15.1717 2.17056C14.9172 2.28278 14.6887 2.44669 14.5009 2.65189L7.3454 10.4857C7.2802 10.5571 7.23071 10.6413 7.20013 10.733L6.35875 13.2554C6.26147 13.547 6.3103 13.8695 6.48933 14.118C6.6698 14.3685 6.96053 14.5181 7.2671 14.5181C7.39971 14.5181 7.52937 14.4908 7.6523 14.437L10.0884 13.3713C10.177 13.3325 10.2564 13.2756 10.3216 13.2043L17.4772 5.3705C18.2218 4.55537 18.1643 3.28641 17.349 2.54158ZM7.97081 12.7894L8.46453 11.3093L8.50617 11.2637L9.44192 12.1184L9.40028 12.164L7.97081 12.7894ZM16.4569 4.43856L10.3739 11.0983L9.4381 10.2436L15.5212 3.58382C15.6401 3.45357 15.803 3.3818 15.9796 3.3818C16.1346 3.3818 16.2831 3.43947 16.398 3.5444L16.4173 3.56204C16.6699 3.79275 16.6876 4.18597 16.4569 4.43856Z",
    fill: "#3936EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9605 8.37511C15.5789 8.37511 15.2696 8.68445 15.2696 9.06601V14.9316C15.2696 15.9005 14.4814 16.6887 13.5125 16.6887H5.13886C4.16998 16.6887 3.3818 15.9005 3.3818 14.9316V6.62598C3.3818 5.65715 4.17003 4.86892 5.13886 4.86892H11.1998C11.5813 4.86892 11.8907 4.55959 11.8907 4.17802C11.8907 3.79646 11.5813 3.48712 11.1998 3.48712H5.13886C3.40806 3.48712 2 4.89523 2 6.62598V14.9316C2 16.6623 3.4081 18.0704 5.13886 18.0704H13.5125C15.2432 18.0704 16.6514 16.6623 16.6514 14.9316V9.06601C16.6514 8.68445 16.3421 8.37511 15.9605 8.37511Z",
    fill: "#3936EF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.290a1993b5d2243a4bdd64be120240ca.svg";
export { ForwardRef as ReactComponent };